import { articlesMetadata } from '../data/articlesMetadata';
import { articleContents, ArticleId } from '../content/articleContent';

export const getAllArticles = () => {
  return articlesMetadata;
};

export const getArticleContent = async (id: string): Promise<string> => {
  try {
    return articleContents[id as ArticleId] || '';
  } catch (error) {
    console.error(`Failed to load article: ${id}`, error);
    return '';
  }
};

export const getArticleMetadata = (id: string) => {
  return articlesMetadata.find(article => article.id === id);
};